"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilEnrichmentCal = void 0;
const calculator_1 = require("../calculator");
class SoilEnrichmentCal {
    static calculate(req) {
        const constants = req.soilEnrichmentConstants;
        return Number((constants.emissionFactor * req.weight).toFixed(calculator_1.PRECISION));
    }
}
exports.SoilEnrichmentCal = SoilEnrichmentCal;
